import styled from "styled-components";
import { CalendarInputContainer } from "../addTourPageComponents/addTourCalendar/pricesCalendarInput.style";

export const AdminTourCalendarElementContainer = styled(
  CalendarInputContainer
)``;
